import React, { useState } from "react";
import { Card, Col, Stack } from "react-bootstrap";
import { unsavedChanges } from "../../../App";
import Input from "../../ui/Input";
import SelectObject from "../../ui/SelectObject";
import { deleteField, patchField, reorderFields } from "../../../services/httpClient";
import IconButton from "../../ui/IconButton";
import { faCheck, faClose } from "@fortawesome/free-solid-svg-icons";
import ReorderEditDeleteCards from "../../ui/ReorderEditDeleteCards";

interface FieldState {
  fields: any;
  getFields: any;
  setOrgToSave: any;
  setErrMessage: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
}

const FieldCards = ({ fields, getFields, setOrgToSave, setErrMessage, setShowToast, setToastText, setToastBody }: FieldState) => {
  const [currentLabel, setCurrentLabel] = useState<string>("");
  const [currentType, setCurrentType] = useState<string>("");
  const [customEditId, setCustomEditId] = useState<string>();

  const fieldOptions = [
    { key: "checkbox", name: "Checkbox" },
    { key: "date", name: "Date" },
    { key: "text", name: "Text" },
    { key: "multi-line text", name: "Multi-Line Text" },
  ];

  const handleEdit = (id: any) => {
    setCurrentLabel("");
    setCurrentType("");
    setCustomEditId(id);
  };

  const onClickEditFinal = (fieldId: any) => {
    const originalField = fields.find((f: any) => f.id === fieldId);

    const updatedField = {
      label: currentLabel ? currentLabel : originalField?.label,
      type: currentType ? currentType : originalField?.type,
    };

    setErrMessage("");

    patchField(updatedField, fieldId)
      .then((res: any) => {
        unsavedChanges.value = false;
        setOrgToSave(false);
        setShowToast(true);
        setToastText("Field Updated");
        setToastBody(currentLabel ? currentLabel : originalField?.label);
        setCustomEditId("");
        getFields();
      })
      .catch((err: any) => {
        setErrMessage(err?.response?.data?.msg);
        window.scrollTo({
          top: 0,
          behavior: "auto",
        });
      });
  };

  const onClickCancelEdit = () => {
    setCustomEditId("");
    unsavedChanges.value = false;
    setOrgToSave(false);
    setErrMessage(undefined);
  };

  const onClickDeleteFinal = (fieldId: any) => {
    deleteField(fieldId)
      .then((res: any) => {
        setShowToast(true);
        setToastText("Field Deleted");
        setToastBody(fields.find((f: any) => f.id === fieldId)?.label || "Unknown Field");
        getFields();
      })
      .catch((err: any) => {
        setErrMessage(err?.response?.data?.msg);
        window.scrollTo({
          top: 0,
          behavior: "auto",
        });
      });
  };

  const onUpdateLabel = (e: any) => {
    setCurrentLabel(e.target.value);
    unsavedChanges.value = true;
    setOrgToSave(true);
    setErrMessage(undefined);
  };

  const onUpdateType = (e: any) => {
    setCurrentType(e.target.value);
    unsavedChanges.value = true;
    setOrgToSave(true);
    setErrMessage(undefined);
  };

  const renderEdit = (fieldId: any) => {
    const originalField = fields.find((f: any) => f.id === fieldId);

    return (
      <Card className="mb-2">
        <Card.Body>
          <Stack direction="horizontal" gap={3}>
            <Col>
              <Input
                label="Label"
                type="text"
                value={currentLabel ? currentLabel : originalField?.label || ""}
                onUpdate={(e: any) => onUpdateLabel(e)}
                required={true}
                hasFocus={true}
              />
            </Col>
            <Col>
              <SelectObject
                label="Type"
                value={currentType ? currentType : originalField?.type || ""}
                options={fieldOptions}
                onUpdate={(e: any) => onUpdateType(e)}
                required={true}
                skipInitialOption={true}
              />
            </Col>
            <IconButton onClickButton={() => onClickEditFinal(fieldId)} tooltipText={"Save"} icon={faCheck} />
            <div className="vr" />
            <IconButton onClickButton={onClickCancelEdit} tooltipText={"Cancel"} icon={faClose} />
          </Stack>
        </Card.Body>
      </Card>
    );
  };

  const updateFieldOrder = (newOrder: any) => {
    reorderFields(newOrder)
      .then(() => {
        setShowToast(true);
        setToastText("Field Order Updated");
        setToastBody("The field order has been updated.");
        getFields();
      })
      .catch((err) => {
        setErrMessage(err?.response?.data?.msg);
      });
  };

  return (
    <>
      {fields?.length > 0 && (
        <Stack gap={2}>
          <ReorderEditDeleteCards
            items={fields}
            onDeleteFinal={onClickDeleteFinal}
            updateOrder={updateFieldOrder}
            customRenderEdit={renderEdit}
            customEditId={customEditId}
            handleEdit={handleEdit}
            setErrMessage={setErrMessage}
          />
        </Stack>
      )}
    </>
  );
};

export default FieldCards;
